var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgScanOutline = function SvgScanOutline(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.79,
    height: 144.785
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }, /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 1380",
    d: "M102.089 143.66h20.788a20.788 20.788 0 0 0 20.787-20.788v-20.788"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 1381",
    d: "M143.66 42.701V21.913a20.788 20.788 0 0 0-20.788-20.787h-20.788"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 1382",
    d: "M42.701 143.66H21.913a20.788 20.788 0 0 1-20.787-20.788v-20.788"
  }), /*#__PURE__*/React.createElement(Path, {
    "data-name": "Pfad 1383",
    d: "M1.13 42.701V21.913A20.788 20.788 0 0 1 21.918 1.126h20.788"
  }))));
};
export default SvgScanOutline;